// src/components/demo/DemoBanner.js

import { useTranslation } from "react-i18next";
import { useDemo } from "../../hooks/useDemo";
import "../../scss/demo.scss";

function DemoBanner() {
  const { t } = useTranslation();
  const { isDemoMode, exitDemo } = useDemo();

  if (!isDemoMode) return null;

  return (
    <div className="demo-banner">
      <div className="demo-banner-left">
        <span className="demo-banner-badge">DEMO</span>
        <span>{t("demo.bannerMessage")}</span>
      </div>
      <button className="demo-banner-exit" onClick={exitDemo}>
        {t("demo.exitDemo")}
      </button>
    </div>
  );
}

export default DemoBanner;
